import SectionTitle from "../../../../common/sectionTitle";
import skeletonLaying from "../../../../assets/skeleton-images/layOnRibs-min.png";

// import AboutInfoCardList from "../aboutInfoCardList";

import data from "../../../../assets/data/about/aboutv1";
import aboutThumb from "../../../../assets/skeleton-images/SidePoint1.png";

import AboutStyleWrapper from "./About.style";

const About = () => {
  const { aboutDescription1, aboutDescription2 } = data;
  return (
    <AboutStyleWrapper id="about">
      <div className="container">
        <div className="row flex-row-reverse">
          <div className="col-md-6">
            <div className="v1_about_us_right_sect">
              <SectionTitle title="ABOUT US" subtitle="THE STORY " />
              <div className="v1_about_us_right_text">
                <p>{aboutDescription1}</p>
                <p>{aboutDescription2}</p>
              </div>

              <img className="skeleton-lying" src={skeletonLaying} alt="skeleton laying sideways" />
            </div>
          </div>
          <div className="col-md-6">
            <div className="v1_about_us_left_sect sm-mt-60">
           
                <div className="v1_about_us_img v1_about_us_img1">
                  <img src={aboutThumb} alt="img" />
                </div>
              </div>
              </div>
            </div>
          </div>
    </AboutStyleWrapper>
  );
};

export default About;
